import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=8c64d656&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style1 from "./Content.vue?vue&type=style&index=1&id=8c64d656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c64d656",
  null
  
)

export default component.exports